import { render, staticRenderFns } from "./LinkedinChannelDetail.vue?vue&type=template&id=02db46b6&scoped=true"
import script from "./LinkedinChannelDetail.vue?vue&type=script&lang=js"
export * from "./LinkedinChannelDetail.vue?vue&type=script&lang=js"
import style0 from "./LinkedinChannelDetail.vue?vue&type=style&index=0&id=02db46b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02db46b6",
  null
  
)

export default component.exports